import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-page-header-with-button",
  templateUrl: "./page-header-with-button.component.html",
  styleUrls: ["./page-header-with-button.component.scss"],
})

/**
 * Page Header With Button Component
 * Componente reutilizável para cabeçalho de páginas com botão de ação e subtexto
 */
export class PageHeaderWithButtonComponent {
  @Input() title: string = "";
  
  @Input() icon: string | undefined;
  
  @Input() subtitle: string = "";

  @Input() buttonText: string = "";

  @Input() buttonIcon: string = "fas fa-plus";

  @Input() buttonDisabled: boolean = false;

  @Input() buttonClass: string = "btn btn-primary btn-sm";

  @Output() buttonClick = new EventEmitter<void>();

  onButtonClick(): void {
    if (!this.buttonDisabled) {
      this.buttonClick.emit();
    }
  }
}
